export enum Taxons {
  phylum,
  class,
  order,
  family,
  genus,
  species
}

export const TaxonNames: Record<Taxons, string> = {
  [Taxons.phylum]: 'Phylum',
  [Taxons.class]: 'Class',
  [Taxons.order]: 'Order',
  [Taxons.family]: 'Family',
  [Taxons.genus]: 'Genus',
  [Taxons.species]: 'Species'
}
